import React from 'react';
import { motion } from 'framer-motion';
import { useOrbs } from '../../context/OrbContext';

// Helper function to convert hex to rgba
const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const FloatingOrbs: React.FC = () => {
  const { orbColors, isLoading: orbColorsLoading } = useOrbs();

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {!orbColorsLoading && (
        <div className="absolute inset-0">
        {/* Large orb */}
        <motion.div
          className="absolute w-[800px] h-[800px] rounded-[100%] opacity-60"
          style={{
            background: `radial-gradient(circle at center, ${hexToRgba(orbColors.blob1, 0.4)} 0%, ${hexToRgba(orbColors.blob1, 0)} 70%)`,
            filter: 'blur(80px)',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          animate={{
            scale: [1, 1.1, 1],
            x: ['-30vw', '30vw', '-30vw'],
            y: ['-10vh', '20vh', '-10vh'],
          }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: [0.4, 0, 0.6, 1],
            times: [0, 0.5, 1],
          }}
        />

        {/* Medium orb */}
        <motion.div
          className="absolute w-[600px] h-[600px] rounded-[100%] opacity-60"
          style={{
            background: `radial-gradient(circle at center, ${hexToRgba(orbColors.blob2, 0.4)} 0%, ${hexToRgba(orbColors.blob2, 0)} 70%)`,
            filter: 'blur(80px)',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          animate={{
            scale: [1.1, 1, 1.1],
            x: ['20vw', '-25vw', '20vw'],
            y: ['15vh', '-20vh', '15vh'],
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: [0.4, 0, 0.6, 1],
            times: [0, 0.5, 1],
          }}
        />

        {/* Small accent orb */}
        <motion.div
          className="absolute w-[400px] h-[400px] rounded-[100%] opacity-60"
          style={{
            background: `radial-gradient(circle at center, ${hexToRgba(orbColors.blob3, 0.4)} 0%, ${hexToRgba(orbColors.blob3, 0)} 70%)`,
            filter: 'blur(80px)',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          animate={{
            scale: [1, 1.2, 1],
            x: ['-20vw', '15vw', '-20vw'],
            y: ['10vh', '-15vh', '10vh'],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: [0.4, 0, 0.6, 1],
            times: [0, 0.5, 1],
          }}
        />
        </div>
      )}
    </div>
  );
};